import React from "react";

const ReviewsComments = ({ reviewsComments }) => {
  return (
    <div className="reviews-comment mt-5">
      <ul>
        {/* {reviewsComments.map((comment) => (
          <li>{comment.reviewTitle}</li>
        ))} */}
      </ul>
    </div>
  );
};

export default ReviewsComments;
